module.exports = __webpack_public_path__ + "img/245.6273f277.jpg";